import React, { Component, Dispatch } from 'react';
import { Modal } from 'reactstrap';
import { Common } from '../../../../../core/common';
import Translator from '../../../../../core/i18n';
import { Log } from 'ng2-logger';
import { connect } from 'react-redux';
import { IAction, IAppState } from '../../../../../models/action/core';
import { ISelectedExamSession } from '../../../../../models/action/examSession';
import { IPreference } from '../../../../../models/action/profile';
import AddSessionTabs from './addSessionTabs';
import SessionProperties from './sessionProperties';
import AddQuestion from './addQuestion';
import * as Actions from '../../../../../store/actions/examSession';
import { Confirm, Notification } from '../../../../../components/notification/main';
import Questions from './questions';
import AddStudents from './addStudents';
import AddSecurity from './addSecurity';
import Students from './students';
import Publishing from './publishing';
import { IExamData } from '../../../../../models/action/exam';
import { FormikContext } from 'formik';

let _common: Common;
const T = Translator.create();
const _logger = Log.create('Exam Session Add Page');

interface IAddExamSessionState {
    currentTab: string;
    validations: any;
}

interface IAddExamSessionProps {
    isModalOpen: boolean;
    examSessionId: string;
    setCloseModal: (examSessionId: string, currentTab: string) => void;
    dispatch?: any;
    selectedExamSession?: ISelectedExamSession;
    userPreferences?: IPreference[];
    updateActivityId?: string;
    formik: FormikContext<IExamData>;
    setExamSessionId: (examSessionId: string) => void;
    currentTab: string;
}

class AddExamSession extends Component<IAddExamSessionProps, IAddExamSessionState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            currentTab: '_sessionProperties',
            validations: {}
        };
    }

    componentDidUpdate (prevProps: IAddExamSessionProps) {
        if (this.props.currentTab !== prevProps.currentTab) {
            this.setState({ currentTab: this.props.currentTab });
        }
    }

    onCloseModal = () => {
        this.props.dispatch(Actions.ExamSessionSetUpdateDefault());
        this.props.dispatch(Actions.ExamSessionAddStudentListDefault());

        this.props.setCloseModal('', '');
        this.setState({
            currentTab: '_sessionProperties'
        });
    };

    public onClickDeleteFile = () => {
        Confirm.setConfirm('checkControl', () => this.onCloseModal(), T.t('r_close_session_modal'), null);
    };
    
    changeTab = (tabName: string) => {
        if(this.props.examSessionId) {
            this.props.setExamSessionId.bind(this,this.props.examSessionId)
            this.setState({
                currentTab: tabName
            });
        } else {
            Notification.setNotification(
                'error',
                T.t('r_gen_exam_session_not_found_error'),
                'topRight'
            );
        }
    };

    render() {
        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '100vw',margin:'0' }}
                isOpen={this.props.isModalOpen}
                toggle={this.onCloseModal}
            >
                <div className="modal-content" style={{height:'100vh'}}>
                    <div className="modal-header">
                        <h6 className="modal-title d-inline-flex align-items-center ml-auto ml-auto-title" id="exampleModalLabel">
                            {T.t('r_gen_exam_session_modal')}
                        </h6>
                        <button type="button" className="close modal-exam-close" data-dismiss="modal" aria-label="Close" onClick={this.onClickDeleteFile}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body" style={{ padding: 0 ,background: 'rgb(251, 250, 246)' }}>
                        <div className="container-fluid p-0">
                            <div className="row mt-0">
                                <div className="col-12 modal-from-right">
                                    <AddSessionTabs changeTab={this.changeTab} currentTab={this.state.currentTab} />
                                    <div className="tab-content" id="tabContent" style={{ padding: '3rem', background: '#fbfaf6' }}>
                                        <SessionProperties 
                                            examSessionId={this.props.examSessionId} 
                                            examId={this.props.updateActivityId}
                                            updateActivityId={this.props.updateActivityId} 
                                            currentTab={this.state.currentTab}
                                            formik={this.props.formik}
                                            setExamSessionId={this.props.setExamSessionId}
                                        />
                                        <AddQuestion 
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                        />
                                        <Questions 
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                        />
                                        <Students 
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                        />
                                        <AddStudents 
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                        />
                                        <AddSecurity
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                            updateActivityId={this.props.updateActivityId}
                                            formik={this.props.formik}
                                            setExamSessionId={this.props.setExamSessionId}
                                        />
                                        <Publishing 
                                            currentTab={this.state.currentTab}
                                            examSessionId={this.props.examSessionId}
                                            examId={this.props.updateActivityId}
                                            changeTab={this.changeTab}
                                            setExamSessionId={this.props.setExamSessionId}
                                            formik={this.props.formik}
                                            setCloseModal={ this.props.setCloseModal}                                   />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.onCloseModal}>{T.t('r_fileUpload_cancel')}</button>
                    </div>
                    */}
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IAddExamSessionProps): IAddExamSessionProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IAddExamSessionProps = Object.assign({}, ownProps, {
        selectedExamSession: state.examSession.selectedSession,
        userPreferences: state.profile.userPreferences.preferences
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.examSession.selectedSession === prev.examSession.selectedSession &&
        next.profile.userPreferences === prev.profile.userPreferences
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CAddExamSession = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(AddExamSession);

export default CAddExamSession;
